<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">投票延期审核</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.voteTitle" placeholder="请输入投票标题" class="figma-search-input" clearable @keyup.enter.native="_queryMethod" />
            <el-input size="small" v-model="conditions.communityName" placeholder="请输入小区名称" class="figma-search-input" clearable @keyup.enter.native="_queryMethod" />
            <el-select size="small" v-model="conditions.state" placeholder="请选择状态" class="figma-search-select" clearable>
              <el-option label="全部" value="" />
              <el-option label="待审核" value="0" />
              <el-option label="已通过" value="1" />
              <el-option label="已驳回" value="2" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="550"
          :fit="true"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="applyId" label="申请ID" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.applyId || '-' }}</template>
          </el-table-column>
          <el-table-column prop="voteTitle" label="投票标题" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.voteTitle || '-' }}</template>
          </el-table-column>
          <el-table-column prop="communityName" label="小区名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="applicantName" label="申请人" min-width="100" align="center">
            <template slot-scope="scope">{{ scope.row.applicantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="applicantLink" label="联系方式" min-width="130" align="center">
            <template slot-scope="scope">{{ scope.row.applicantLink || '-' }}</template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.applyTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="delayEndTime" label="延期截止时间" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.delayEndTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="attachments" label="附件" min-width="160" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.attachments || scope.row.attachments === '[]'">-</span>
              <span v-else class="attachment-links">
                <a v-for="(item, idx) in parseAttachments(scope.row.attachments)" :key="idx" class="action-link" :href="item.url" target="_blank">{{ item.name }}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" min-width="100" align="center">
            <template slot-scope="scope">
              <span :class="['status-tag', getStateClass(scope.row.state)]">{{ getStateText(scope.row.state) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <span class="action-links">
                <template v-if="String(scope.row.state) === '0'">
                  <a class="action-link action-link-approve" @click="_approveRow(scope.row)">通过</a>
                  <a class="action-link action-link-danger" @click="_rejectRow(scope.row)">驳回</a>
                </template>
                <template v-else>
                  <span>-</span>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.current"
          :page-size="pagination.size"
          layout="prev, pager, next"
          :total="pagination.total"
          :pager-count="7"
          @current-change="handleCurrentChange"
        />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { listVoteDelayApplies, approveVoteDelay, rejectVoteDelay } from '@/api/platform/platformApi'
import { getUserName } from '@/api/user/userApi'

export default {
  name: 'VoteDelayAuditList',
  data() {
    return {
      conditions: { voteTitle: '', communityName: '', state: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this._listData(this.pagination.current, this.pagination.size) },
  methods: {
    _listData(page, size) {
      const params = { ...this.conditions, page, row: size }
      listVoteDelayApplies(params).then(res => {
        this.tableData = Array.isArray(res.data) ? res.data : (Array.isArray(res.records) ? res.records : [])
        this.pagination.total = res.count || res.total || 0
      }).catch(error => { console.error('请求失败', error) })
    },
    _queryMethod() { this.pagination.current = 1; this._listData(this.pagination.current, this.pagination.size) },
    _approveRow(row) {
      this.$prompt('请输入审核意见', '通过申请', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入审核意见（选填）',
        inputValue: ''
      }).then(({ value }) => {
        const params = {
          applyId: row.applyId,
          auditorName: getUserName() || '',
          auditRemark: value || ''
        }
        approveVoteDelay(params).then(() => {
          this.$message.success('审核通过成功')
          this._queryMethod()
        }).catch(error => {
          console.error('操作失败', error)
          this.$message.error(error.message || '审核通过失败')
        })
      }).catch(() => {})
    },
    _rejectRow(row) {
      this.$prompt('请输入驳回原因', '驳回申请', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入驳回原因',
        inputValue: '',
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return '驳回原因不能为空'
          }
          return true
        }
      }).then(({ value }) => {
        const params = {
          applyId: row.applyId,
          auditorName: getUserName() || '',
          auditRemark: value || ''
        }
        rejectVoteDelay(params).then(() => {
          this.$message.success('驳回成功')
          this._queryMethod()
        }).catch(error => {
          console.error('操作失败', error)
          this.$message.error(error.message || '驳回失败')
        })
      }).catch(() => {})
    },
    getStateClass(state) { return { '0': 'status-pending', '1': 'status-approved', '2': 'status-rejected' }[String(state)] || 'status-pending' },
    getStateText(state) { return { '0': '待审核', '1': '已通过', '2': '已驳回' }[String(state)] || '-' },
    parseAttachments(attachments) {
      if (!attachments) return []
      // 去除可能存在的首尾反引号、空格等
      let raw = String(attachments).trim()
      if (!raw) return []
      // 情况1：JSON 数组字符串（标准格式）
      if (raw.startsWith('[') || raw.startsWith('{')) {
        try {
          const list = JSON.parse(raw)
          if (Array.isArray(list)) {
            // 兼容 url/fileUrl、name/fileName 等字段别名
            return list.map(item => ({
              url: item.url || item.fileUrl || item.annexUrl || '',
              name: item.name || item.fileName || item.annexName || (item.url ? this._extractFileName(item.url) : '附件')
            })).filter(item => item.url)
          }
          // 单个对象也包成数组
          if (list && typeof list === 'object') {
            const url = list.url || list.fileUrl || list.annexUrl || ''
            if (url) {
              return [{ url, name: list.name || list.fileName || list.annexName || this._extractFileName(url) }]
            }
          }
        } catch (e) {
          // JSON 解析失败，继续走兜底逻辑
        }
      }
      // 情况2：纯 URL 字符串（兼容单条，或以逗号/分号分隔的多条）
      const urls = raw.split(/[,;；，\s]+/).filter(Boolean)
      if (urls.length) {
        return urls.map(url => ({ url, name: this._extractFileName(url) }))
      }
      return []
    },
    _extractFileName(url) {
      if (!url) return '附件'
      try {
        // 去掉 query 参数，取最后一段路径作为文件名
        const withoutQuery = String(url).split('?')[0].split('#')[0]
        const parts = withoutQuery.split('/')
        const last = parts[parts.length - 1]
        return last && decodeURIComponent(last) ? decodeURIComponent(last) : '附件'
      } catch (e) {
        return '附件'
      }
    },
    handleSizeChange(val) { this.pagination.size = val; this.pagination.current = 1; this._listData(this.pagination.current, val) },
    handleCurrentChange(val) { this.pagination.current = val; this._listData(val, this.pagination.size) },
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' } },
    cellStyle({ row }) { const i = this.tableData.indexOf(row); return i % 2 === 1 ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' } : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' } }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 92px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: #FFFFFF; border-radius: 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 24px; gap: 0; }
.figma-page-title { height: 22px; line-height: 22px; font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin: 0 0 22px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 23px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; height: 38px; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-refresh { height: 38px; width: 38px; padding: 0 !important; border-radius: 10px !important; border: none !important; outline: 1px solid #DCE6F5 !important; outline-offset: -1px; background: #FFFFFF !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; }
.figma-btn-refresh:hover { outline-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; line-height: 38px; padding: 0 16px; font-size: 14px; color: #1D2129; background: #FFFFFF; font-family: 'Inter', 'PingFang SC'; }
.figma-search-input >>> .el-input__inner::placeholder { color: #8C9BB4; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-search-select { width: 180px; height: 38px; }
.figma-search-select >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: #FFFFFF; }
.figma-search-select >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { width: 84px; height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: #FFFFFF !important; font-size: 14px; font-weight: 500; padding: 0 !important; display: inline-flex; align-items: center; justify-content: center; gap: 6px; font-family: 'Inter', 'PingFang SC'; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 0 0 550px; height: 550px; padding: 0 24px; overflow: auto; box-sizing: border-box; }
.figma-table-section >>> .el-table { border-radius: 0; overflow: hidden; border: none; color: #1D2129; font-family: 'PingFang SC'; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body td { border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF !important; }
.figma-table-section >>> .el-table::before,
.figma-table-section >>> .el-table__fixed-right::before,
.figma-table-section >>> .el-table__fixed::before { display: none; }
.figma-table-section >>> .el-table .cell { height: 50px; line-height: 22px; padding: 14px 24px !important; box-sizing: border-box; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.figma-table-section >>> .el-table__header .cell { color: #364153; font-weight: 400; }
.status-tag { display: inline-block; padding: 4px 12px; border-radius: 4px; font-size: 12px; line-height: 18px; font-weight: 500; font-family: 'PingFang SC'; }
.status-pending { background: #FFF7E6; color: #FA8C16; }
.status-approved { background: #E6F7E6; color: #21B956; }
.status-rejected { background: #FFE6E6; color: #FB2C36; }
.attachment-links { display: inline-flex; flex-direction: column; gap: 4px; align-items: center; }
.action-links { display: inline-flex; align-items: center; justify-content: center; gap: 18px; height: 22px; }
.action-link { color: #0E76FF; font-size: 14px; line-height: 22px; font-weight: 500; cursor: pointer; text-decoration: none; font-family: 'PingFang SC'; }
.action-link:hover { color: #0E76FF; text-decoration: none; }
.action-link-approve { color: #21B956; }
.action-link-danger { color: #FB2C36; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; height: 32px; padding: 18px 19px 0 24px; gap: 8px; border-top: none; box-sizing: content-box; }
.pagination-total { font-size: 14px; line-height: 22px; color: #1D2129; font-family: 'PingFang SC'; margin-right: 0; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; padding: 0; color: #364153; font-weight: 600; }
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next,
.figma-pagination >>> .el-pager li { min-width: 32px; width: 32px; height: 32px; line-height: 32px; border-radius: 2px; margin: 0 4px; padding: 0; background: transparent; color: #364153; font-family: 'Nunito Sans', 'PingFang SC'; font-size: 14px; font-weight: 600; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; height: 32px; margin-left: 4px; }
.pagination-size-select >>> .el-input__inner { height: 32px; line-height: 32px; border-radius: 2px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; padding: 0 28px 0 12px; }
.pagination-size-select >>> .el-input__suffix { right: 4px; }
@media (max-width: 1280px) {
  .figma-table-section { flex-basis: calc(100vh - 300px); height: calc(100vh - 300px); }
}
@media (max-width: 768px) {
  .figma-page-header { padding: 16px; }
  .figma-header-row { height: auto; flex-direction: column; align-items: stretch; gap: 12px; }
  .figma-search-group { width: 100%; flex-wrap: wrap; }
  .figma-search-input { flex: 1; min-width: 180px; }
  .figma-table-section { padding: 0 16px; }
  .figma-pagination { justify-content: flex-start; flex-wrap: wrap; padding: 16px; height: auto; }
}
</style>
